import React from 'react';
export const Text = props => {
  const {
    param,
    data
  } = props;
  return <div>{data[param.key] || <em>No value specified</em>}</div>;
};